import classNames from "classnames";
import React from "react";
import styles from "./widgetFormTextInput.css";
import TextareaAutosize from "react-textarea-autosize";
import { staticConfig } from "@fidget/common/config/static-config";

interface Props
  extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, "height" | "style"> {
  errorHint?: string;
  hasError?: boolean;
}
export const WidgetFormTextInput = ({ errorHint, hasError, ...rest }: Props) => {
  return (
    <div className={styles["input-wrap"]}>
      <TextareaAutosize
        minRows={1}
        maxRows={staticConfig.messageWidgetTextInputMaxRows}
        className={classNames({ [styles["has-error"]]: hasError })}
        {...rest}
      />
      {hasError && <div className={styles["error-message"]}>{errorHint}</div>}
    </div>
  );
};
